import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { logger } from '../../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../../utils/validators/string';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { signMemberOut } from '../authentication/sign-member-out';
export const validateMemberPasswordResetCode = async (resetCode) => {
    if (!nonEmptyStringValidator(resetCode, logger.error, 'validatePasswordResetCode')) {
        throw new Error('Cannot validate password reset code without a reset code');
    }
    const result = await ocapiClient.instance.v1.loyalty.members.passwordReset.validateCode({ resetCode });
    // If a member is already signed in and they successfully validate their reset code, then we will sign them out so that they can sign in with their new password.
    if (result.isValid && isMemberSignedIn())
        await signMemberOut();
    return result;
};
